import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { TemplateType } from '@ap/pega';

import { ProductOpenenDirective } from '../product-openen/product-openen.directive';
import { CasePrefix, DistributionChannelType } from '../product-openen/product-openen.model';

@Component({
    selector: 'mijn-product-openen',
    templateUrl: './mijn-product-openen.component.html',
    standalone: false
})
export class MijnProductOpenenComponent extends ProductOpenenDirective implements OnDestroy, OnInit {
    public templateType: TemplateType = TemplateType.ACTION;
    public useState = true;
    private readonly subscription = new Subscription();

    public ngOnInit(): void {
        super.ngOnInit();
        this.content.DistributionChannelType = DistributionChannelType.MIJN;
    }

    public onCaseChange(fullCaseId: string): void {
        const [, caseId] = fullCaseId.split(' ');
        const [casePrefix] = (caseId || '').split('-');
        if (casePrefix !== CasePrefix.ORIENTATION) {
            this.useState = false;

            if (this.requestType === undefined) {
                this.subscription.add(
                    this.pegaResource
                        .getData('D_CLMCaseDetailsFEP', {
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            InsKey: fullCaseId
                        })
                        .pipe(map((pegaData) => pegaData.CombinedJourney))
                        .subscribe((combinedJourney) => {
                            if (typeof combinedJourney === 'string') {
                                // eslint-disable-next-line no-param-reassign
                                combinedJourney = JSON.parse(combinedJourney);
                            }
                            this.requestType = combinedJourney ? 'Joint' : 'Single';
                            this.title = this.getTitle();
                        })
                );
            }
        }
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
